import React from "react";
import styled, { css } from "styled-components";

interface InfoListItemProps {
  title: string;
  children: React.ReactNode;
  direction?: "row" | "column";
}

const InfoListItem = ({
  title,
  children,
  direction = "row",
}: InfoListItemProps) => {
  return (
    <InfoListItemLayout direction={direction}>
      <h3>{title}</h3>
      <div>{children}</div>
    </InfoListItemLayout>
  );
};

export default InfoListItem;

const InfoListItemLayout = styled.div<{ direction: "row" | "column" }>`
  display: flex;
  flex-direction: ${(props) => props.direction};
  gap: 1rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      gap: 0.6rem;
    }
  `}

  h3 {
    min-width: 12rem;
  }
  div {
    flex: 1;
  }
`;
